import { Injectable, inject } from '@angular/core';
import { HateoasResourceService, Resource } from '@lagoshny/ngx-hateoas-client';
import { Subscription } from 'rxjs';
import { ResourceCommandStream } from './resource-command-stream.service';
import { ResourceContext } from './resource-context.service';

@Injectable({
  providedIn: 'root',
})
export class ResourceContextStore {
  private commandStream = inject(ResourceCommandStream);
  private hateoasResourceService = inject(HateoasResourceService);

  private _contextDictionary: Record<string, ResourceContext<Resource>> = {};
  private _resourceEventsSubscriptions: Record<string, Subscription> = {};

  public reset() {
    for (const key in this._contextDictionary) {
      this.removeByKey(key);
    }
    this._contextDictionary = {};
    this._resourceEventsSubscriptions = {};
  }

  public flush(message = '') {
    return this.commandStream.flush(message);
  }

  public getByKey<T extends Resource>(key: string): ResourceContext<T> {
    return this._contextDictionary[key] as ResourceContext<T>;
  }

  public getByResource<T extends Resource>(resource: T, createIfNotExists = true): ResourceContext<T> {
    if (!resource) return;
    const key = ResourceContext.getResourceKey(resource);
    const context = this.getByKey(key);
    if (!context && createIfNotExists) {
      return this.add(resource);
    }
    return this.getByKey(key);
  }

  public add<T extends Resource>(resource: T): ResourceContext<T> {
    const key = ResourceContext.getResourceKey(resource);
    if (this._contextDictionary[key]) return;

    const context = new ResourceContext(resource, this.commandStream, this.hateoasResourceService);
    this._contextDictionary[key] = context;

    return this.getByKey(key);
  }

  public removeByResource<T extends Resource>(resource: T) {
    const key = ResourceContext.getResourceKey(resource);
    this.removeByKey(key);
  }

  public removeByKey(key: string) {
    const resource = this._contextDictionary[key];
    if (!resource) return;
    this._resourceEventsSubscriptions[key]?.unsubscribe();
    delete this._resourceEventsSubscriptions[key];
    delete this._contextDictionary[key];
  }
}
